import { Factory, trait } from 'miragejs';

export default Factory.extend({
  withQuestions: trait({
    afterCreate(signInFieldPage, server) {
      server.createList('sign-in-field', 3, 'asSingleSelectionWithOptions', { signInFieldPage });
    },
  }),

  withEmailAddressSignInField: trait({
    afterCreate(signInFieldPage, server) {
      signInFieldPage.signInFields.add(
        server.create('sign-in-field', 'asEmailAddress', {
          signInFieldPage,
        })
      );
    },
  }),

  withFullNameSignInField: trait({
    afterCreate(signInFieldPage, server) {
      signInFieldPage.signInFields.add(
        server.create('sign-in-field', 'asFullName', {
          signInFieldPage,
        })
      );
    },
  }),

  withSingleSelectionSignInField: trait({
    afterCreate(signInFieldPage, server) {
      const signInFields = server.createList('sign-in-field', 3, 'asSingleSelectionWithOptions', {
        signInFieldPage,
      });

      signInFields.forEach((field) => signInFieldPage.signInFields.add(field));

      const signInFieldAction = server.create('sign-in-field-action', {
        signInFieldId: signInFieldPage.signInFieldIds[0],
        action: 'alert',
        matchOperator: 'is',
        signInFieldValue: 1,
      });

      const groups = server.createList('sign-in-field-action-rule-group', 3, {
        flow: signInFieldPage.flow,
        actions: ['alert'],
      });

      groups.forEach((group) => group.signInFieldActions.add(signInFieldAction));
    },
  }),
});
